// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"504":"chunk-vendors","3524":"app"}[chunkId] + "." + {"504":"a317e429","3524":"f6d96eb7"}[chunkId] + ".css";
};